/**
 * Class to work as a DTO to hold the information of a event dispatched the google ads event.
 */
class GoogleAdsEvent {
  constructor(eventName, enhancedConversionData = {}) {
    this.event = 'googleAdsEvent';
    this.eventName = eventName;
    this.ecData = enhancedConversionData;
  }

  /**
   * The function returns the value of the eventName property.
   * @returns The value of the variable `eventName`.
   */
  getEvent() {
    return this.event;
  }

  /**
   * The function returns the value of the "ecData" property.
   * @returns The `ecData` property is being returned.
   */
  getEnhancedConversionData() {
    return this.ecData;
  }
}

export default GoogleAdsEvent;
